import styled, { css } from "styled-components/native";
import { compose, variant } from "../../../../theming/styledSystem";
import { stylesStepBarUncompleted } from "../styles";
import { ProgressBarVariant } from "../../types";
import { Theme } from "../../../../theming/types";

const stylesStepBarUncompletedText = compose(
  variant({
    prop: "variant",
    variants: {
      dark: {
        color: "blue.800"
      },
      light: {
        color: "blue.300"
      }
    }
  })
);

export const StyledAchievementStepContainer = styled.View<{
  isCompleted?: boolean;
  variant: ProgressBarVariant;
  isMobile: boolean;
  theme: Theme;
}>`
  display: flex;
  height: ${({ isMobile }: { isMobile: boolean }) =>
    isMobile ? "24px" : "32px"};
  width: ${({ isMobile }: { isMobile: boolean }) =>
    isMobile ? "24px" : "32px"};
  border-radius: ${({ isMobile }: { isMobile: boolean }) =>
    isMobile ? "24px" : "32px"};
  justify-content: center;
  align-items: center;
  margin-left: 1px;
  ${({ theme, isCompleted }: { theme: Theme; isCompleted?: boolean }) =>
    isCompleted
      ? css`
          background-color: ${theme.colors.green[500]};
          color: ${theme.colors.white[900]};
        `
      : css`
          background-color: ${theme.colors.blue[100]};
          ${stylesStepBarUncompleted}
        `}
`;

export const StyledAchievementStepText = styled.Text<{
  isCompleted?: boolean;
  variant: ProgressBarVariant;
  isMobile: boolean;
  theme: Theme;
  children?: React.ReactNode;
}>`
  ${({ theme, isMobile }: { theme: Theme; isMobile: boolean }) => css`
    font-family: ${theme.fonts.regular};
    font-size: ${isMobile ? theme.fontSizes.s : theme.fontSizes.l};
    font-weight: ${theme.fontWeights.bold};
  `}

  ${({ theme, isCompleted }: { theme: Theme; isCompleted?: boolean }) =>
    isCompleted
      ? css`
          color: ${theme.colors.white[900]};
        `
      : stylesStepBarUncompletedText}
`;
